var poll_default = {
  "fontElementMap": "ZlXjH",
  "container": "_48cuq",
  "fullscreen": "vt7nL",
  "background_overlay": "-kRYR",
  "with_image": "QFT--",
  "options": "IQLqH",
  "webview": "_1ZazG",
  "grid": "jXSRi",
  "option": "d2eSg",
  "cta_button": "jvoLb",
  "add_option": "HO2j1",
  "see_more": "guW23",
  "list": "DLpoV",
  "column": "ZbmT7",
  "additional_note": "ZNufF",
  "spinner": "T-5tY",
  "spin": "_691bi",
  "shown": "b3IOi",
  "error": "kO-3U"
};
export {
  poll_default as default
};
//# sourceMappingURL=poll-scss.js.map
